module.exports = __webpack_public_path__ + "img/celoan.0c8afd6d.jpg";